import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';

function UpdatePackegeDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [venues, setVenues] = useState([]);
  const [selectedTopVenues, setSelectedTopVenues] = useState([]);

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    featuredImage: null,
    galleryImages: null,
    centerContentImage: null,
    bookingInfoImage: null,
    bookingDescription: '',
    bookingLink: '',
    attributeBestFor: '',
    attributeBestSeason: '',
    isFeatured: false,
    topText: '',
    leftText: '',
    rightText: ''
  });

  const [plans, setPlans] = useState([{ title: '', description: '', others: [] }]);
  const [additionalDetails, setAdditionalDetails] = useState([{ text: '', details: [] }]);

  const [existing, setExisting] = useState({
    featuredImage: '',
    centerContentImage: '',
    galleryImages: [],
    bookingInfoImage: ''
  });

  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : (type === 'checkbox' ? checked : value)
    }));
  };

  const handleImageUpload = async (image) => {
    const data = new FormData();
    data.append('image', image);
    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/upload-packege-image`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data?.image;
    } catch (err) {
      console.error('Image upload failed:', err);
      return null;
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [eventRes, venuesRes] = await Promise.all([
          axios.get(`${config.BASE_URL}/api/admin/get-packege/${id}`, { withCredentials: true }),
          axios.get(`${config.BASE_URL}/api/admin/get-venues`, { withCredentials: true })
        ]);

        const event = eventRes.data;
        setVenues(venuesRes.data || []);

        setFormData({
          title: event.title || '',
          description: event.description || '',
          featuredImage: null,
          galleryImages: null,
          centerContentImage: null,
          bookingInfoImage: null,
          bookingDescription: event?.bookingInfo?.description || '',
          bookingLink: event?.bookingInfo?.link || '',
          attributeBestFor: Array.isArray(event.attributeBestFor) ? event.attributeBestFor.join(', ') : '',
          attributeBestSeason: Array.isArray(event.attributeBestSeason) ? event.attributeBestSeason.join(', ') : '',
          isFeatured: !!event.isFeatured,
          topText: event?.centerContent?.topText || '',
          leftText: event?.centerContent?.leftText || '',
          rightText: event?.centerContent?.rightText || ''
        });

        setSelectedTopVenues((event.topVenues || []).map(v => typeof v === 'string' ? v : v?._id).filter(Boolean));
        setPlans(Array.isArray(event.plans) && event.plans.length ? event.plans : [{ title: '', description: '', others: [] }]);
        setAdditionalDetails(Array.isArray(event.additionalDetails) && event.additionalDetails.length ? event.additionalDetails : [{ text: '', details: [] }]);

        setExisting({
          featuredImage: event.featuredImage || '',
          centerContentImage: event.centerContentImage || '',
          galleryImages: event.galleryImages || [],
          bookingInfoImage: event?.bookingInfo?.image || ''
        });

        setLoading(false);
      } catch (err) {
        setError('Failed to fetch packege');
        setLoading(false);
      }
    };
    fetchAll();
  }, [id]);

  // Plans handlers
  const addPlan = () => setPlans(prev => [...prev, { title: '', description: '', others: [] }]);
  const removePlan = (index) => setPlans(prev => prev.filter((_, i) => i !== index));
  const handlePlanChange = (index, field, value) => {
    setPlans(prev => prev.map((p, i) => (i === index ? { ...p, [field]: value } : p)));
  };
  const addPlanOther = (planIndex) => {
    setPlans(prev => prev.map((p, i) => (i === planIndex ? { ...p, others: [...p.others, { image: '', text: '' }] } : p)));
  };
  const removePlanOther = (planIndex, otherIndex) => {
    setPlans(prev => prev.map((p, i) => (i === planIndex ? { ...p, others: p.others.filter((_, oi) => oi !== otherIndex) } : p)));
  };
  const handlePlanOtherChange = (planIndex, otherIndex, field, value) => {
    setPlans(prev => prev.map((p, i) => {
      if (i !== planIndex) return p;
      return { ...p, others: p.others.map((o, oi) => (oi === otherIndex ? { ...o, [field]: value } : o)) };
    }));
  };

  // Additional details handlers
  const addAdditionalSection = () => setAdditionalDetails(prev => [...prev, { text: '', details: [] }]);
  const removeAdditionalSection = (index) => setAdditionalDetails(prev => prev.filter((_, i) => i !== index));
  const handleAdditionalSectionChange = (index, value) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === index ? { ...s, text: value } : s)));
  };
  const addAdditionalDetail = (sectionIndex) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === sectionIndex ? { ...s, details: [...s.details, { image: '', description: '' }] } : s)));
  };
  const removeAdditionalDetail = (sectionIndex, detailIndex) => {
    setAdditionalDetails(prev => prev.map((s, i) => (i === sectionIndex ? { ...s, details: s.details.filter((_, di) => di !== detailIndex) } : s)));
  };
  const handleAdditionalDetailChange = (sectionIndex, detailIndex, field, value) => {
    setAdditionalDetails(prev => prev.map((s, i) => {
      if (i !== sectionIndex) return s;
      return { ...s, details: s.details.map((d, di) => (di === detailIndex ? { ...d, [field]: value } : d)) };
    }));
  };

  const removeServerImage = async (imageName) => {
    try {
      await axios.post(`${config.BASE_URL}/api/admin/remove-event-image`, { eventId: id, imageName }, { withCredentials: true });
      setExisting(prev => ({
        ...prev,
        featuredImage: prev.featuredImage === imageName ? '' : prev.featuredImage,
        centerContentImage: prev.centerContentImage === imageName ? '' : prev.centerContentImage,
        galleryImages: (prev.galleryImages || []).filter(img => img !== imageName),
        bookingInfoImage: prev.bookingInfoImage === imageName ? '' : prev.bookingInfoImage
      }));
    } catch (err) {
      console.error('Failed to remove image', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitLoading(true);

    try {
      const filteredPlans = (plans || [])
        .filter(p => (p?.title || '').trim() !== '')
        .map(p => ({
          title: p.title,
          description: (p.description || '').trim(),
          others: (p.others || []).filter(o => (o?.text || '').trim() !== '' || (o?.image || '').trim() !== '')
        }));

      const filteredAdditionalDetails = (additionalDetails || [])
        .filter(s => (s?.text || '').trim() !== '' || (s?.details || []).some(d => (d?.description || '').trim() !== '' || (d?.image || '').trim() !== ''))
        .map(s => ({
          text: s.text,
          details: (s.details || []).filter(d => (d?.description || '').trim() !== '' || (d?.image || '').trim() !== '')
        }));

      const data = new FormData();
      data.append('title', formData.title);
      data.append('description', formData.description || '');
      data.append('centerContent', JSON.stringify({ topText: formData.topText, leftText: formData.leftText, rightText: formData.rightText }));
      const bestFor = (formData.attributeBestFor || '').split(',').map(s => s.trim()).filter(Boolean);
      const bestSeason = (formData.attributeBestSeason || '').split(',').map(s => s.trim()).filter(Boolean);
      const topVenues = selectedTopVenues;
      data.append('attributeBestFor', JSON.stringify(bestFor));
      data.append('attributeBestSeason', JSON.stringify(bestSeason));
      data.append('topVenues', JSON.stringify(topVenues));
      data.append('plans', JSON.stringify(filteredPlans));
      data.append('additionalDetails', JSON.stringify(filteredAdditionalDetails));
      const bookingInfo = { description: formData.bookingDescription || '', link: formData.bookingLink || '' };
      data.append('bookingInfo', JSON.stringify(bookingInfo));
      data.append('isFeatured', formData.isFeatured);

      if (formData.galleryImages) {
        for (let i = 0; i < formData.galleryImages.length; i++) {
          data.append('galleryImages', formData.galleryImages[i]);
        }
      }
      if (formData.featuredImage) data.append('featuredImage', formData.featuredImage[0]);
      if (formData.centerContentImage) data.append('centerContentImage', formData.centerContentImage[0]);
      if (formData.bookingInfoImage) data.append('bookingInfoImage', formData.bookingInfoImage[0]);

      await axios.put(`${config.BASE_URL}/api/admin/update-packege/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      setSuccessMessage('Packege updated successfully!');
      navigate('/admin/packages');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update event');
    } finally {
      setSubmitLoading(false);
    }
  };

  if (loading) return <div className="dashboard update_detail_wrap"><div className="container"><p>Loading...</p></div></div>;

  return (
    <div className="dashboard update_detail_wrap">
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="container">
        <h1 className="dash_title">Edit Packege</h1>
        <div className="back_btn_wrap">
          <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="update_details_wrap">
            <div className="form-group">
              <label>Packege Title</label>
              <input type="text" value={formData.title} name="title" required onChange={(e) => handleInputChange(e.target)} />
            </div>

            <div className="form-group textareaField">
              <label>Description</label>
              <textarea value={formData.description} name="description" onChange={(e) => handleInputChange(e.target)} />
            </div>

            <div className="form-group">
              <label>Featured Image</label>
              <input type="file" name="featuredImage" onChange={(e) => handleInputChange(e.target)} />
              {existing.featuredImage && (
                <div className="detail_img_item" style={{ marginTop: 12 }}>
                  <img src={`${config.BASE_URL}${existing.featuredImage}`} alt="featured" style={{ maxWidth: 200 }} />
                  <div>
                    <button type="button" className="remove_btn" onClick={() => removeServerImage(existing.featuredImage)}>Remove</button>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="form-group">
              <label>Gallery Images (add more)</label>
              <input type="file" name="galleryImages" multiple onChange={(e) => handleInputChange(e.target)} />
              {(existing.galleryImages || []).length > 0 && (
                <div className="detail_img_grid" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                  {existing.galleryImages.map((img, idx) => (
                    <div key={idx} className="detail_img_item">
                      <img src={`${config.BASE_URL}${img}`} alt={`gallery-${idx}`} style={{ width: 120, height: 120, objectFit: 'cover' }} />
                      <div>
                        <button type="button" className="remove_btn" onClick={() => removeServerImage(img)}>Remove</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div> */}

            <div className="form-group">
              <h2>Best For </h2>
              <input type="text" placeholder="Best For (comma separated)" name="attributeBestFor" value={formData.attributeBestFor} onChange={(e) => handleInputChange(e.target)} />
              <h2>Best Season</h2>
              <input type="text" placeholder="Best Season (comma separated)" name="attributeBestSeason" value={formData.attributeBestSeason} onChange={(e) => handleInputChange(e.target)} />
            </div>

            {/* <div className="form-group">
              <h2>Top Venues</h2>
              <select
                multiple
                value={selectedTopVenues}
                onChange={(e) => {
                  const options = Array.from(e.target.selectedOptions).map(o => o.value);
                  setSelectedTopVenues(options);
                }}
              >
                {venues.map(v => (
                  <option key={v._id} value={v._id}>{v.title}</option>
                ))}
              </select>
            </div> */}

            <div className="form-group">
              <h2>Center Content</h2>
              <label>Image</label>
              <input type="file" name="centerContentImage" onChange={(e) => handleInputChange(e.target)} />
              {existing.centerContentImage && (
                <div className="detail_img_item" style={{ marginTop: 12 }}>
                  <img src={`${config.BASE_URL}${existing.centerContentImage}`} alt="center" style={{ maxWidth: 200 }} />
                  <div>
                    <button type="button" className="remove_btn" onClick={() => removeServerImage(existing.centerContentImage)}>Remove</button>
                  </div>
                </div>
              )}

              {/* <label>Top Text</label>
              <input type="text" name="topText" value={formData.topText} onChange={(e) => handleInputChange(e.target)} /> */}
              <label>Left Text</label>
              <input type="text" name="leftText" value={formData.leftText} onChange={(e) => handleInputChange(e.target)} />
              <label>Right Text</label>
              <input type="text" name="rightText" value={formData.rightText} onChange={(e) => handleInputChange(e.target)} />
            </div>
            <div className="form-login bg-gray-rounded">
              <div className="add_field itineraryFields">
                <h1>Plans     <button type="button" onClick={addPlan}>Add Plan</button>
                </h1>
                {plans.map((plan, pi) => (
                  <>
                    <div key={pi} className="addItineraryFields">
                      <div className="add_field">
                        <h2>{pi + 1}. Plan   <button type="button" onClick={() => removePlan(pi)}>Remove Plan</button>
                        </h2>
                        <h2>Title</h2>
                        <input type="text" value={plan.title} onChange={(e) => handlePlanChange(pi, 'title', e.target.value)} />
                      </div>
                      <div className="add_field">
                        <h2>Description</h2>
                        <input type="text" value={plan.description} onChange={(e) => handlePlanChange(pi, 'description', e.target.value)} />
                      </div>

                    </div>
                    <div key={pi} className="addItineraryFields">

                      <div className="add_field titleField">
                        <h2>Others</h2>
                        {plan.others.map((other, oi) => (
                          <>
                            <div key={oi} className="addItineraryFields">
                              <div className="add_field titleField">
                                <h3>Text
                                </h3>
                                <input type="text" value={other.text} onChange={(e) => handlePlanOtherChange(pi, oi, 'text', e.target.value)} />
                              </div>

                              <button type="button" onClick={() => removePlanOther(pi, oi)}>Remove Item</button>
                            </div>
                            <div className="add_field ">
                              <h3>Image</h3>
                              <input type="file" onChange={async (e) => {
                                const file = e.target.files && e.target.files[0];
                                if (file) {
                                  const url = await handleImageUpload(file);
                                  if (url) handlePlanOtherChange(pi, oi, 'image', url);
                                }
                              }} />
                              {other.image && (
                                <div className="detail_img_item" style={{ marginTop: 8 }}>
                                  <img src={`${config.BASE_URL}${other.image}`} alt="plan-other" style={{ maxWidth: 200 }} />
                                </div>
                              )}
                            </div>

                          </>
                        ))}
                        <button type="button" onClick={() => addPlanOther(pi)}>Add Other</button>
                        <hr />
                      </div>

                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="add_field itineraryFields  bg-gray-rounded">
              <h1>Additional Details</h1>
              {additionalDetails.map((section, si) => (
                <>
                  <div key={si} className="">
                    <div className="add_field titleField">
                      <h2>Section Title</h2>
                      <input type="text" value={section.text} onChange={(e) => handleAdditionalSectionChange(si, e.target.value)} />
                    </div>
                  </div>
                  <div key={si} className="">

                    <div className="add_field titleField mt-5">
                      <h2>Items</h2>
                      {section.details.map((detail, di) => (
                        <div key={di} className="">
                           <h2>{di+1}. Item</h2>
                          <div className="add_field titleField">
                            <h3>Title   <button type="button" onClick={() => removeAdditionalDetail(si, di)}>Remove Item</button>
                            </h3>
                            <input type="text" value={detail.description} onChange={(e) => handleAdditionalDetailChange(si, di, 'description', e.target.value)} />
                          </div>
                          <div className="add_field">
                            <h3>Image</h3>
                            <input type="file" onChange={async (e) => {
                              const file = e.target.files && e.target.files[0];
                              if (file) {
                                const url = await handleImageUpload(file);
                                if (url) handleAdditionalDetailChange(si, di, 'image', url);
                              }
                            }} />
                            {detail.image && (
                              <div className="detail_img_item" style={{ marginTop: 8 }}>
                                <img src={`${config.BASE_URL}${detail.image}`} alt="additional-detail" style={{ maxWidth: 200 }} />
                              </div>
                            )}
                          </div>
                          <hr />
                        </div>
                      ))}
                      <button type="button" onClick={() => addAdditionalDetail(si)}>Add Item</button>
                    </div>
                    {/* <button type="button" onClick={() => removeAdditionalSection(si)}>Remove Section</button> */}
                  </div>
                </>
              ))}
              {/* <button type="button" onClick={addAdditionalSection}>Add Section</button> */}
            </div>
            <div><br /></div>
            <div className=" bg-gray-rounded">
              <div className="form-group ">
                <label>Booking Description</label>
                <input type="text" name="bookingDescription" value={formData.bookingDescription} onChange={(e) => handleInputChange(e.target)} />
              </div>
              <div className="form-group">
                <label>Booking Link</label>
                <input type="text" name="bookingLink" value={formData.bookingLink} onChange={(e) => handleInputChange(e.target)} />
              </div>
              <div className="form-group">
                <label>Booking Image</label>
                <input type="file" name="bookingInfoImage" onChange={(e) => handleInputChange(e.target)} />
                {existing.bookingInfoImage && (
                  <div className="detail_img_item" style={{ marginTop: 12 }}>
                    <img src={`${config.BASE_URL}${existing.bookingInfoImage}`} alt="booking" style={{ maxWidth: 200 }} />
                    <div>
                      <button type="button" className="remove_btn" onClick={() => removeServerImage(existing.bookingInfoImage)}>Remove</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label>
                <input type="checkbox" name="isFeatured" checked={!!formData.isFeatured} onChange={(e) => handleInputChange(e.target)} />
                Set as Featured
              </label>
            </div>

            <div className="update_btn_wrap">
              <button
                className="update_btn"
                type="submit"
                disabled={submitLoading}
                style={{
                  opacity: submitLoading ? 0.6 : 1,
                  cursor: submitLoading ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                {submitLoading && (
                  <div
                    style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}
                  />
                )}
                {submitLoading ? 'Updating...' : 'Update Event'}
              </button>
            </div>
            {successMessage && <p className="success-message">{successMessage}</p>}
            {error && <p className="error-message">{error}</p>}
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdatePackegeDetail;
